import { CarComparisonStore } from '../store'
import { TrimSelectorComparisonResult } from '../trim-selector/trim-selector-comparison-result'
import { VehicleCard } from './vehicle-card'

/**
 * Comparison Result Vehicle Card Component 🚘
 */
export class ComparisonResultsCard extends VehicleCard {
    public get trimSelector(): TrimSelectorComparisonResult {
        return CarComparisonStore.getInstance().getTrimSelectorVehicle()
    }

    public constructor(public wrapper: HTMLElement) {
        super(wrapper)
    }
}
